module.exports = __webpack_public_path__ + "img/cocinillas.05d8991f.jpg";